import { AxiosResponse } from 'axios';
import { call, put, takeLatest } from 'redux-saga/effects';
import { tokenOrderAPI } from 'redux/api/authApi';
import { authAction } from 'redux/slices/authSlice';

function* getTokenOrderSaga(action: any) {
  try {
    const response: AxiosResponse<string> = yield call(tokenOrderAPI, action.payload, {
      appName: action.payload.appName,
    });
    yield put(authAction.getTokenOrderSuccess(response.data));
  } catch (error) {}
}

export default function* authSaga() {
  yield takeLatest(authAction.getTokenOrder, getTokenOrderSaga);
}
